import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-engineering.png?size=600';

const metaDescription = "Consultants indépendants en Ingénierie technique (hors IT) : recevez, consultez et postulez" +
  " à des missions de management de transition et interim management avec notre plateforme.";

const metaOgDescription = "Twineeds met en relation les entreprises avec les consultants indépendants et les " +
  "managers de transition sur les fonctions support et ingénierie";

export default class LandingFreelanceEngineering extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        metaDescription={metaDescription}
        metaTitle="Missions pour professionnels en Ingénierie"
        sectorText="de l'ingénierie"
        universeCode="engineering"
        metaOgDescription={metaOgDescription}
        metaOgTitle="Missions pour professionnels en Ingénierie"
      />
    )
  }
}
